export function formatErrorsFromAPI(errObject: object, replaceString: string) {
  let errorArray: string[] = [];
  for (const key in errObject) {
    Array.isArray(errObject[key])
      ? errObject[key].map(string => errorArray.push(string.split(replaceString).join('')))
      : errorArray.push(errObject[key]);
  }
  return errorArray;
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/formatErrorsFromApi.ts